import React from "react"
import { Button, Modal, Col, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import ActionButton from "../ActionButton"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"
import { APIError } from "../../api/ObservableFromFetch"
import ImplementationUserLabels, { CreateEmptyImplementationUserLabels } from "../../api/Administration/Model/ImplementationUserLabels"
import GetImplementationUserLabels, { SaveImplementationUserLabels } from "../../api/Administration/ImplementationUserLabels"

interface UserLabelsModalProps { }

interface UserLabelsModalState {
  loading: boolean
  saving: boolean
  User1: string
  User2: string
  User3: string
  User4: string
  User5: string
  User6: string
  User7: string
  User8: string
  User9: string
  User10: string
}

export default class UserLabelsModal extends React.PureComponent<UserLabelsModalProps, UserLabelsModalState> {
  emptyState: UserLabelsModalState = {
    loading: false,
    saving: false,
    User1: "",
    User2: "",
    User3: "",
    User4: "",
    User5: "",
    User6: "",
    User7: "",
    User8: "",
    User9: "",
    User10: ""

  }
  state: UserLabelsModalState = { ...this.emptyState }

  loadSubscription?: Subscription
  saveSubscription?: Subscription

  componentDidMount() {
    this.loadInitialData()
  }

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }

  loadInitialData() {

    this.loadSubscription && this.loadSubscription.unsubscribe()

    this.setState({
      loading: true, saving: false
    })

    this.loadSubscription = GetImplementationUserLabels().subscribe(
      (data: ImplementationUserLabels) => {
        this.onDataLoaded(data)
      },
      (error) => this.handleAPIError(error, { loading: false, saving: false })
    )
  }

  onDataLoaded = (data: ImplementationUserLabels) => {
    this.setState({
      loading: false,
      saving: false,
      User1: data.User1,
      User2: data.User2,
      User3: data.User3,
      User4: data.User4,
      User5: data.User5,
      User6: data.User6,
      User7: data.User7,
      User8: data.User8,
      User9: data.User9,
      User10: data.User10
    })
  }

  dataFromState = (): ImplementationUserLabels => {
    const result = CreateEmptyImplementationUserLabels()
    result.User1 = this.state.User1
    result.User2 = this.state.User2
    result.User3 = this.state.User3
    result.User4 = this.state.User4
    result.User5 = this.state.User5
    result.User6 = this.state.User6
    result.User7 = this.state.User7
    result.User8 = this.state.User8
    result.User9 = this.state.User9
    result.User10 = this.state.User10
    return result
  }
  handleCancel = () => (this.props as RouteComponentProps).history?.push(Home)

  handleSave = () => {
    this.setState({ loading: false, saving: true })

    const userLabels = this.dataFromState()
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = SaveImplementationUserLabels(userLabels).subscribe(
      (data: ImplementationUserLabels) => {
        this.onDataLoaded(data)
        toast.success("Record saved successfully")
      },
      error => this.handleAPIError(error, { loading: false, saving: false })
    )
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  render() {
    const { loading, saving, User1, User2, User3, User4, User5, User6, User7, User8, User9, User10 } = this.state
    const inProgress = loading || saving
    return (
      <AppPageWrapper showNav>
        <Modal.Dialog size="lg">
          <Modal.Header>
            <Modal.Title className="text-uppercase">User Code Labels</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_1">User1Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_1" type="text" value={User1}
                  onChange={e => this.setState({ User1: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_2">User2Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_2" type="text" value={User2}
                  onChange={e => this.setState({ User2: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_3">User3Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_3" type="text" value={User3}
                  onChange={e => this.setState({ User3: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_4">User4Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_4" type="text" value={User4}
                  onChange={e => this.setState({ User4: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_5">User5Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_5" type="text" value={User5}
                  onChange={e => this.setState({ User5: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_6">User6Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_6" type="text" value={User6}
                  onChange={e => this.setState({ User6: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_7">User7Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_7" type="text" value={User7}
                  onChange={e => this.setState({ User7: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_8">User8Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_8" type="text" value={User8}
                  onChange={e => this.setState({ User8: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_9"><span style={{color: "blue"}}>*</span>&nbsp;User9Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_9" type="text" value={User9}
                  onChange={e => this.setState({ User9: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Form.Label column sm={3} htmlFor="user_label_10"><span style={{color: "blue"}}>*&nbsp;</span>User10Label:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  id="user_label_10" type="text" value={User10}
                  onChange={e => this.setState({ User10: e.target.value })} />
              </Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Col sm={12}>
              <span style={{color: "blue"}}>* These fields are free text fields, meaning they will not have codes defined for them.</span>
              </Col>
            </Form.Row>

          </Modal.Body>
          <Modal.Footer>
            <ActionButton variant="primary" onClick={() => this.handleSave()} disabled={inProgress} spin={inProgress} disableOnSpin>Save</ActionButton>
            <Button variant="secondary" className="mr-2" onClick={() => this.handleCancel()}>Cancel</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </AppPageWrapper>
    )
  }
}